import React from 'react';

const MediaTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex space-x-4 border-b">
      <button
        className={`px-4 py-2 border-b-2 ${activeTab === 'all' ? 'border-b-blue-600 font-semibold' : 'border-b-transparent'}`}
        onClick={() => onTabChange('all')}
      >
        All
      </button>
      <button
        className={`px-4 py-2 border-b-2 ${activeTab === 'document' ? 'border-b-blue-600 font-semibold' : 'border-b-transparent'}`}
        onClick={() => onTabChange('document')}
      >
        Documents
      </button>
      <button
        className={`px-4 py-2 border-b-2 ${activeTab === 'image' ? 'border-b-blue-600 font-semibold' : 'border-b-transparent'}`}
        onClick={() => onTabChange('image')}
      >
        Photos
      </button>
    </div>
  );
};

export default MediaTabs;